import { ComponentPropsWithRef, forwardRef } from 'react';

import clsx from 'clsx';

import styles from './helpText.module.css';

export type HelpTextProps = ComponentPropsWithRef<'div'>;

export const HelpText = forwardRef<HTMLDivElement, HelpTextProps>(({ className, ...props }, ref) => (
	<div
		ref={ref}
		className={clsx(styles.root, className)}
		data-helptext
		{...props}
	/>
));
